<template>
  <div class="tw-container tw-m-auto tw-mt-32 md:tw-w-2/3 tw-p-4 tw-w-full">
    <div class="md:tw-text-right tw-font-sans tw-text-center md:tw-text-3xl tw-text-3xl tw-mr-4">
      <h1>{{ selectedLanguage == 'US' ? en.title_2 : pt.title_2 }}</h1>
    </div>
    <hr class="tw-border-dashed tw-border-sky-700 tw-mt-1">
    <div class="tw-flex tw-flex-col tw-mt-3 tw-items-center" v-if="!Object.keys(shows).length">
      <p class="tw-text-white tw-font-sans tw-text-sm">{{ selectedLanguage == 'US' ? en.info_show : pt.info_show }}</p>
    </div>
    <section id="shows" class="tw-py-8 tw-mb-12" v-if="Object.keys(shows).length">
      <div class="tw-container tw-mx-auto">
        <div class="tw-flex tw-flex-col tw-mt-3">
          <div class="tw-border-b tw-border-gray-700 tw-px-4 md:tw-px-0" v-for="(show, index) in shows" :key="index">
            <div class="tw-flex tw-flex-row tw-flex-wrap lg:tw-flex-nowrap">
              <div class="tw-flex tw-flex-row tw-flex-grow tw-border-l-0 tw-h-auto event-wrapper tw-w-8">
                <div class="tw-flex tw-flex-1 tw-flex-col md:tw-flex-row">
                  <div class="event-date">
                    <div
                      class="tw-font-sans tw-text-base tw-leading-5 tw-mr-3 md:tw-mr-0 tw-text-white tw-font-black tw-uppercase">
                      {{ new Intl.DateTimeFormat('en-us', { day: 'numeric' }).format(new Date(show.date)) }}
                      {{ new Intl.DateTimeFormat('pt-br', { month: 'short' }).format(new Date(show.date)) }}
                    </div>
                    <div class="tw-font-sans tw-text-sm tw-leading-5 tw-mr-0 tw-text-white tw-font-light">
                      {{ new Intl.DateTimeFormat('pt-br', { weekday: 'short' }).format(new Date(show.date)) }}
                      {{ show.date ? ' • ' + new Intl.DateTimeFormat('pt-br', {
                        hour: "numeric", minute:
                          "numeric"
                      }).format(new Date(show.date)) : '' }}</div>
                  </div>
                  <div class="tw-flex tw-flex-1 tw-flex-row">
                    <div class="event-details">
                      <div class="event-details__header">
                        <div class="event-details__inner tw-truncate">
                          <div class="tw-block tw-w-full tw-truncate">
                            <div class="tw-font-sans tw-truncate tw-text-white tw-text-base tw-leading-5 lg:tw-w-9/12">
                              {{ show.title }}</div>
                            <div class="tw-font-sans tw-truncate tw-text-white tw-font-light tw-text-sm tw-leading-5">
                              {{ show.location }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-actions tw-flex tw-w-full lg:tw-w-2/12 tw--mt-5 lg:tw-mt-0 tw-mb-5 lg:tw-mb-0">
                <a :href="show.link" v-if="show.link" class="hover:tw-bg-white hover:tw-text-black" target="_blank"
                  v-ripple>{{ selectedLanguage == 'US' ? en.ticket : pt.ticket }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout2';
import EventBus from '@/eventbus';
import pt from "../../../../../lang/smartsite/layout_2/layout_2.js";


export default {
  mixins: [pt],
  layout: (h, page) => h(Layout, [page]),
  layout: Layout,
  props: ['artist', 'pageOptions', 'spotifyArtist', 'shows'],
  computed: {
    selectedLanguage() {
      return this.$page.props.lang;
    }
  },
  mounted() {
    console.log(this.shows)
  },
  created() {
    EventBus.$emit('artist', { 'artist': this.artist, 'pageOptions': this.pageOptions });
  }
}
</script>

<style>
.event-wrapper {
  padding: 24px 0px;
  margin: 0px 24px 0px 0px;
  max-height: 300px;
  border-left: none;
}

.event-date {
  display: flex;
  margin-bottom: 8px;
  flex-flow: row wrap;
}

@media screen and (min-width: 768px) {
  .event-date {
    margin-bottom: 0px;
    margin-right: 8px;
    width: 13ch;
    flex-flow: column nowrap;
  }
}

.event-details {
  display: grid;
  grid-template-areas: "header";
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  width: 100%;
}

.event-details__header {
  display: flex;
  flex-flow: row;
  grid-area: header / header / header / header;
}

.event-details__inner {
  max-height: 600px;
  opacity: 1;
  visibility: visible;
  transition: max-height 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s, opacity 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.2s, margin-bottom 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
  align-items: flex-start;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  flex: 1 1 0%;
  flex-flow: row;
  max-width: 80vw;
}

@media(min-width:1280px) {
  .event-details__inner {
    max-width: 950px;
  }
}

.right-actions {
  display: flex;
  padding-top: 24px;
  flex-shrink: 0;
  flex-flow: column;
}

.right-actions a {
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  text-align: center;
  font-weight: 600;
  line-height: 36px;
  margin-bottom: 4px;
  max-height: 36px;
  min-width: 106px;
  font-weight: 600;
  font-size: 14px;
  line-height: 2.43;
  width: 100%;
  min-width: 60px;
  text-align: center;
  text-transform: capitalize;
  cursor: pointer;
  color: rgb(255, 255, 255);
  border: 1px solid rgba(255, 255, 255, 0.78);
  display: block;
  padding: 0px 12px;
  border-radius: 2px;
  transition: background-color 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
  text-decoration: none;
}
</style>
